export const T = {
  en_GB: {
    admin: "Admin",
    title: "Tenants Overview",
    description: "All tenants with usage statistics.",
    name: "Name",
    slug: "Slug",
    users: "Users",
    yau: "YAU",
    mau: "MAU",
    dau: "DAU",
    flows: "Flows",
    clients: "Clients",
    noTenants: "No tenants found.",
  },
  nb_NO: {
    admin: "Admin",
    title: "Kundeoversikt",
    description: "Alle kunder med bruksstatistikk.",
    name: "Navn",
    slug: "Slug",
    users: "Brukere",
    yau: "YAU",
    mau: "MAU",
    dau: "DAU",
    flows: "Flyter",
    clients: "Klienter",
    noTenants: "Ingen kunder funnet.",
  },
} as const;
